import { datadogRum } from '@datadog/browser-rum'
import { datadogLogs } from '@datadog/browser-logs'

// Initiate DataDog Real User Monitoring
try {
  datadogRum.init({
    applicationId: 'b1f43e33-a830-42ab-9736-3966bfe810fa',
    clientToken: 'pubc25578d4740f3b6878cca728ce88e427',
    site: 'datadoghq.com',
    service:'pb-wealth-partners',
    env: parseDatadogEnv(),
    // Specify a version number to identify the deployed version of your application in Datadog
    version: process.env.VUE_APP_VERSION,
    sessionSampleRate: 100,
    sessionReplaySampleRate: 100,
    trackUserInteractions: true,
    trackResources: true,
    trackLongTasks: true,
    trackFrustrations: true,
    defaultPrivacyLevel: 'mask-user-input',
    allowedTracingUrls: [
      (url) => url.startsWith('https://api-uat.aham.com.my'),
      (url) => url.startsWith('https://api-prod.aham.com.my'),
      // (url) => url.startsWith('https://cms-staging.nadia.com.my'),
      // (url) => url.startsWith('https://cms-uat.nadia.com.my'),
      // (url) => url.startsWith('https://cms.nadia.com.my')
    ]
  })
  datadogRum.startSessionReplayRecording()
} catch (err) {
  console.log('Error in DataDog RUM', err)
}

function parseDatadogEnv () {
  if (process.env.NODE_ENV === 'production') {
    return 'prod'
  } else if (process.env.NODE_ENV === 'uat') {
    return 'preprod'
  } else if (process.env.NODE_ENV === 'staging') {
    return 'dev'
  } else if (process.env.NODE_ENV === 'development') {
    return 'development'
  } else {
    return null
  }
}

// Initiate DataDog Logger
datadogLogs.init({
  clientToken: 'pub4389982767cb149aa05ef605ac4cd074',
  service: 'pb-wealth-partners',
  site: 'datadoghq.com',
  forwardErrorsToLogs: true,
  sessionSampleRate: 100,
  version: process.env.VUE_APP_VERSION,
  env: parseDatadogEnv(),
})

export { datadogRum, datadogLogs }
